import { OrgUnitDto, Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { FunctionComponent } from "react";

import { Dialog, DropdownField, SubmissionForm, Option } from "@bps/fluent-ui";
import { ConsentDto } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.dtos";
import { usePatchConsentLocation } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.hooks";

export interface AddLocationDialogProps {
  item: ConsentDto;
  tenant: Tenant;
  orgUnits: OrgUnitDto[];
  onDismiss: () => void;
}

export interface AddLocationFormValues {
  locationId: string[];
  tenantId: string;
  id: string;
}

export const AddLocationDialog: FunctionComponent<AddLocationDialogProps> = ({
  item,
  tenant,
  orgUnits,
  onDismiss
}) => {
  const { mutateAsync: patchConsentLocation } = usePatchConsentLocation();

  const onSubmit = async (formData: AddLocationFormValues) => {
    await patchConsentLocation({
      locations: formData.locationId,
      tenantId: tenant.id,
      id: item.id
    });
    onDismiss();
  };

  const defaultValues: AddLocationFormValues = {
    locationId: [],
    tenantId: "",
    id: ""
  };

  const orgUnitsOption: Option[] = !orgUnits
    ? []
    : [
        {
          key: "",
          text: "None"
        }
      ].concat(
        orgUnits.map(t => {
          return { key: t.id, text: t.name };
        }) ?? []
      );

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: "Add Location",
        showCloseButton: true,
        onDismiss
      }}
      minWidth={450}
    >
      <SubmissionForm<AddLocationFormValues>
        onSubmit={onSubmit}
        initialValues={defaultValues}
        cancelButtonProps={{ onClick: onDismiss }}
      >
        {() => (
          <DropdownField
            name="locationId"
            placeholder="Select locations id"
            label="Location OrgUnit Id"
            options={orgUnitsOption}
            withNoEmptyOption={true}
            multiSelect={true}
          />
        )}
      </SubmissionForm>
    </Dialog>
  );
};
